import axios from 'axios';

export const API_BASE_URL = 'https://api.indiacastingclub.com';

// Create an Axios instance
const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  // baseURL: 'https://api.staging.hyderabadcastingclub.com/',
});

// Add a request interceptor to attach the token from localStorage
axiosInstance.interceptors.request.use((config) => {

  const token = sessionStorage.getItem('token'); // Retrieve the token from localStorage
  if (token) {
    config.headers['Authorization'] = `Token ${token}`; // Add the token to the request headers
  }

  return config;
});

export default axiosInstance;
